import { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

export default function Layout() {
  // Menu lateral comeca sempre recolhido; o usuario expande quando precisar.
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background-50">
      {/* Overlay para mobile */}
      {mobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black/40 backdrop-blur-sm z-40 md:hidden"
          onClick={() => setMobileMenuOpen(false)}
        ></div>
      )}

      {/* Sidebar mobile — só aparece no mobile quando o menu está aberto */}
      <div
        className={`fixed top-0 left-0 h-full z-50 md:hidden transition-transform duration-300 ${
          mobileMenuOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <Sidebar
          collapsed={false}
          onToggle={() => {}}
          onMobileClose={() => setMobileMenuOpen(false)}
          isMobile
        />
      </div>

      {/* Sidebar desktop — fixed, sempre visível a partir de md */}
      <div className="fixed top-0 left-0 h-full z-50 hidden md:block">
        <Sidebar
          collapsed={sidebarCollapsed}
          onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
        />
      </div>

      {/* Conteúdo principal */}
      <div
        className={`transition-all duration-300 ${
          sidebarCollapsed ? "md:ml-[68px]" : "md:ml-[260px]"
        } ml-0`}
      >
        <Topbar onMenuClick={() => setMobileMenuOpen(true)} />
        <main className="p-4 md:p-6 bg-background-50 min-h-[calc(100vh-4rem)]">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
